import React from 'react';
import {AppBar, Toolbar, IconButton, Icon, Typography} from 'material-ui';
import {withStyles} from 'material-ui/styles';


const styles = {
    root: {
        color: "#f7f7f7"
    }
}

class AppTopBar extends React.Component {
 
    // constructor(){
    //     super(props);

    //     this.state = {
    //         //state goes here
    //     }
    // }


    render(){
        //const { classes } = this.props;

        return (
            <div>
                <AppBar elevation={1} className="primary" position="sticky">
                    <Toolbar classes = {{ root: this.props.classes.root }}>
                        <IconButton className="sample" color="inherit" aria-label="Menu">
                            <Icon>menu</Icon>
                        </IconButton>
                        <Typography color="inherit" variant="subheading">Home</Typography>
                        <div className="flex flex-auto"></div>
                        <IconButton color="inherit">
                            <Icon>search</Icon>
                        </IconButton>
                    </Toolbar>
                </AppBar>
            </div>
        );
    }
}

export default withStyles(styles)(AppTopBar)


// WEBPACK FOOTER //
// ./src/Components/AppTopBar.js